import ENVIRONMENT from '@/environments/environment';

import Api from '../../utils/apiHelper';
import { StoredPaymentCards } from '../payment/paymentCardsStore';
import { ReusePaymentCardResponse } from '../payment/reusePaymentReponseCard';
import { ReusePaymentCardRequest } from '../payment/reusePaymentRequestCard';
import { PaymentResponse } from './tpvPayment';

const TpvAPI = {

  postPaymentAuthorization: (
    creditProposalId: string,
    paymentMethod?: any,
  ): Promise<PaymentResponse> => {
    const data = paymentMethod
      ? Object.assign(ENVIRONMENT.PAYMENTS_URL, { payment_method: paymentMethod })
      : ENVIRONMENT.PAYMENTS_URL;
    return Api.POST(
      `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL}${ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}/payments`,
      data,
    ).then((response) => response.data);
  },
  getPaymentStatus: async (
    creditProposalId: string,
    paymentId: string,
  ): Promise<PaymentResponse> => Api.GET(`${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL}${ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}/payments/${paymentId}`).then((response) => response.data),

  getStoredPaymentCards: async (
    creditProposalId: string,
  ): Promise<StoredPaymentCards> => Api.GET(
    `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL + ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}/payment-cards`,
  ).then((response) => response.data),
  postReusePaymentCard: async (
    creditProposalId: string,
    payment_id: string,
    payment_method_id: string,
  ): Promise<ReusePaymentCardResponse> => {
    const request: ReusePaymentCardRequest = {
      payment_id,
      payment_method_id,
    };
    const response = await Api.POST(
      `${ENVIRONMENT.URL_PROPOSAL.API_CREDIT_PROPOSAL + ENVIRONMENT.URL_PROPOSAL.PROPOSAL}/${creditProposalId}/reuse-payment`,
      request,
    );
    return response.data;
  },
};
export const {
  postPaymentAuthorization, getPaymentStatus, getStoredPaymentCards, postReusePaymentCard,
} = TpvAPI;
